import { render, staticRenderFns } from "./PdfPreviewPage.vue?vue&type=template&id=77a94960&scoped=true&"
import script from "./PdfPreviewPage.vue?vue&type=script&lang=js&"
export * from "./PdfPreviewPage.vue?vue&type=script&lang=js&"
import style0 from "./PdfPreviewPage.vue?vue&type=style&index=0&id=77a94960&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a94960",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
